<template>
  <div id="grid-pagos">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :items="itemsPagos"
              :headers="headers"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.periodo }}</td>
                <td class="text-xs-left">{{ props.item.fechaPago }}</td>
                <td class="text-xs-left">{{ props.item.nroPago }}</td>
                <td class="text-xs-left">{{ props.item.monto }}</td>
                <td class="text-xs-left">{{ props.item.observacion }}</td>
                <td class="text-xs-left">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    title="Descargar registro"
                    small
                    @click="downloadFile(props.item.id, props.item.idContrato)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      props.item.documento != null &&
                      props.item.documento != '' &&
                      props.item.documento !== undefined
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="success"
                    title="Descargar documento"
                    small
                    @click="downloadFile2(props.item.id, props.item.filename)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <!-- LEYENDA TABLA PROVEEDORES -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <div class="text-xs-center">
                <td>
                  <template>
                    <v-btn
                      class="btn-sigas"
                      depressed
                      outline
                      title="Descargar documento"
                      icon
                      fab
                      dark
                      color="primary"
                      small
                    >
                      <v-icon>cloud_download</v-icon> </v-btn
                    >Descargar registro
                    <v-btn
                      class="btn-sigas"
                      depressed
                      outline
                      title="Descargar documento"
                      icon
                      fab
                      dark
                      color="success"
                      small
                    >
                      <v-icon>cloud_download</v-icon> </v-btn
                    >Descargar documento
                  </template>
                </td>
              </div>
            </v-card-actions>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertPago from "@/views/ui/AlertPago.vue";

export default {
  name: "grid-detalle-pago",

  components: {
    Loading,
    AlertPago,
  },
  props: {
    rowsTable: "",
    tipeView: "",
    idContrato: "",
    select: "",
  },

  data() {
    return {
      // idContrato: "",
      loading: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        { text: "Periodo", align: "left", sortable: false, value: "periodo" },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Nro Factura", sortable: false, value: "pago" },
        { text: "Monto", sortable: false, value: "monto" },
        { text: "Observación", sortable: false, value: "observacion" },
        { text: "Acciones", sortable: false, value: "acciones" },
      ],
      usuarioLoggedTipe: "",
      itemsMultas: [],
      multasEstados: [],
      result: [],
      idUserLogged: "",
      proceso: "",
      pagoValue: "",
       itemsPagos:[]
    };
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.proSelectedStored;
    this.idContratoValue;
    this.loadDataConsulta();
  },
  mounted() {},
  computed: {},
  methods: {
    //POST ,  BODY IDCONTRATO,FILENAME
    async downloadFile(id, idContratoIn) {
      let filenameOut = "Descarga_Registro_Pagos_" + id + ".xlsx";
      return await axios
        .get("/pagosMultas/downloadExcelPago/" + id + "/" + idContratoIn, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filenameOut);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadPagosFilter() {
      this.body = {
        idContrato: "",
        id: null,
        perido: null,
        productoReporte: null,
        estado: null,
      };
      return await axios
        .post("/pagosMultas/pagos", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },

    async downloadFile2(idIn, filename) {
      this.body = {
        fileName: filename,
        id: idIn,
      };

      axios
        .post("pagosMultas/downloadAdjunto/", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadDataConsulta() {
      if (this.idContrato > 0) {
        console.log("es mayor");
      }
      this.loading = true;

      this.itemsPagos = await this.loadPagosFilter();

      if (this.itemsPagos.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
  },
};
</script>
